import { Navigate, RouteObject } from 'react-router-dom';

import { AppNotFoundPage } from '@/components';
import { lazyImport } from '@/utils';

import { SignupBuilder } from './SignupBuilder';

const { Signup } = lazyImport(() => import('./Signup'), 'Signup');
const { Subscription } = lazyImport(
  () => import('../../subscription/routes/Subscription'),
  'Subscription',
);

export const signupRoute: RouteObject = {
  path: 'signup',
  element: <SignupBuilder />,
  children: [
    { index: true, element: <Navigate to="signup" /> },
    { path: 'company-info', element: <Signup /> },
    { path: 'subscription', element: <Subscription /> },
    { path: '*', element: <AppNotFoundPage path="signup" /> },
  ],
};
